const ListRegion = () => import('./region/ListRegion.vue')
const EditRegion = () => import('./region/EditRegion.vue')
const NewRegion = () => import('./region/NewRegion.vue')

const ListPlanCategory = () => import('./category/ListPlanCategory.vue')
const EditPlanCategory = () => import('./category/EditPlanCategory.vue')
const NewPlanCategory = () => import('./category/NewPlanCategory.vue')

const ListBasePlan = () => import('./basePlan/ListBasePlan.vue')
const EditBasePlan = () => import('./basePlan/EditBasePlan.vue')
const NewBasePlan = () => import('./basePlan/NewBasePlan.vue')

const TheContainer = () => import('@/containers/TheContainer')
const RouterView = { render: h => h('router-view') }

// Helper per estrarre il nome tradotto (oggetto con chiavi lingua)
const getTranslatedName = (nameObj, fallback) => {
    if (!nameObj) return fallback
    if (typeof nameObj === 'string') return nameObj
    // Prova la lingua corrente, poi 'en', poi la prima disponibile
    const lang = document.documentElement.lang || 'en'
    return nameObj[lang] || nameObj.en || Object.values(nameObj).find(v => v) || fallback
}

// Helper per ottenere il nome della region dallo store
const getRegionName = (context) => {
    const region = context.store.getters['region/region']
    const regionId = context.route.params.region
    if (!region || region.id !== parseInt(regionId)) {
        context.store.dispatch('region/fetchRegion', regionId).catch(() => {})
        return `Region #${regionId}`
    }
    return getTranslatedName(region.name, `Region #${regionId}`)
}

// Helper per ottenere il nome della category dallo store
const getCategoryName = (context) => {
    const category = context.store.getters['region/category']
    const categoryId = context.route.params.category
    const regionId = context.route.params.region
    if (!category || category.id !== parseInt(categoryId)) {
        // Assicuriamoci che regionId sia settato prima di fetchare la category
        context.store.dispatch('region/setRegionId', regionId)
        context.store.dispatch('region/fetchCategory', categoryId).catch(() => {})
        return `Category #${categoryId}`
    }
    return getTranslatedName(category.name, `Category #${categoryId}`)
}

// Base plan routes
const basePlanRoutes = [
    {
        path: 'list',
        name: 'base_plan.list',
        component: ListBasePlan,
        meta: {},
    },
    {
        path: 'new',
        name: 'base_plan.new',
        component: NewBasePlan,
        meta: {
            label: 'Create new Base Plan',
            breadcrumb: {
                text: 'Create'
            }
        },
    },
    {
        path: ':id',
        name: 'base_plan.edit',
        component: EditBasePlan,
        meta: {
            label: 'Edit Base Plan',
            breadcrumb: {
                text: 'Edit'
            }
        },
    },
]

// Category routes
const categoryRoutes = [
    {
        path: 'list',
        name: 'plan_category.list',
        component: ListPlanCategory,
        meta: {},
    },
    {
        path: 'new',
        name: 'plan_category.new',
        component: NewPlanCategory,
        meta: {
            label: 'New category',
            breadcrumb: {
                text: 'Create'
            }
        },
    },
    {
        path: ':id',
        name: 'plan_category.edit',
        component: EditPlanCategory,
        meta: {
            label: 'Edit category',
            breadcrumb: {
                text: 'Edit'
            }
        },
    },
    {
        path: ':category/base_plan',
        name: 'base_plan',
        redirect: to => ({ name: 'base_plan.list', params: to.params }),
        component: RouterView,
        meta: {
            perms: ['admin.base_plan.list'],
            breadcrumb: {
                text: getCategoryName,
                to: (context) => {
                    // No link if we're already on the base plan list
                    if (context.route.name === 'base_plan.list') return undefined
                    return {
                        name: 'base_plan.list',
                        params: {
                            region: context.route.params.region,
                            category: context.route.params.category
                        }
                    }
                }
            }
        },
        children: basePlanRoutes
    },
]

// Region child routes
const regionChildRoutes = [
    {
        path: 'list',
        name: 'region.list',
        component: ListRegion,
        meta: {},
    },
    {
        path: 'new',
        name: 'region.new',
        component: NewRegion,
        meta: {
            label: 'Create new Region',
            breadcrumb: {
                text: 'Create'
            }
        },
    },
    {
        path: ':id',
        name: 'region.edit',
        component: EditRegion,
        meta: {
            label: 'Edit Region',
            breadcrumb: {
                text: 'Edit'
            }
        },
    },
    {
        path: ':region/category',
        name: 'plan_category',
        redirect: to => ({ name: 'plan_category.list', params: to.params }),
        component: RouterView,
        meta: {
            perms: ['admin.plan_category.list'],
            breadcrumb: {
                text: getRegionName,
                to: (context) => {
                    // No link if we're already on the category list
                    if (context.route.name === 'plan_category.list') return undefined
                    return {
                        name: 'plan_category.list',
                        params: { region: context.route.params.region }
                    }
                }
            }
        },
        children: categoryRoutes
    },
]

export default [
    {
        path: '/region',
        name: 'region',
        component: TheContainer,
        meta: {
            perms: ['admin.region.list'],
            breadcrumb: {
                text: 'Regions',
                to: (context) => {
                    if (context.route.name === 'region.list') return undefined
                    return { name: 'region.list' }
                }
            }
        },
        children: regionChildRoutes
    }
]